// extracted by mini-css-extract-plugin
module.exports = {"stickyTableWrapper":"FixStickyTable_stickyTableWrapper__2YicW","measureColumnCell":"FixStickyTable_measureColumnCell__Ye4dL"};